export const CHAIN_ID = process.env.NEXT_PUBLIC_CHAIN_ID
